require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./service-develop-ongoing-devops-support.json") })
        }
      }, "path---service-develop-ongoing-devops-support");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---service-develop-ongoing-devops-support!./.cache/json/service-develop-ongoing-devops-support.json
// module id = 900
// module chunks = 231608221292675